// frontend/src/routes/routes.js

import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";
import PaginaNaoEncontrada from "../PaginaNaoEncontrada";
import Login from "../telas/login/Login";
import Inicio from "../telas/inicio/Inicio";
import { PublicRoute } from "./PublicRoute";
import { PrivateRoute } from "./PrivateRoute";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Sidebar } from "../componentes/SideBar";
import Sobre from "../telas/sobre/Sobre";
import Contato from "../telas/contato/Contato";
import Cadastro from "../telas/cadastro/Cadastro";
import Pdf from "../telas/pdf/Pdf";
import Referencias from "../telas/referencias/referencias";
import PdfCartograma from "../telas/pdf/PdfCartograma";
import PdfCartogramaPrint from "../telas/pdf/PdfCartogramaPrint";
import PdfSerieHistoria from "../telas/pdf/PdfSerieHistoria";
import PdfTabelaSintese from "../telas/pdf/PdfTabelaSintese";
import { useEffect } from "react";
import { sanitizeToken } from "../services/api/postgrest";

const logMessage = (label, ...params) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.info(label, ...params);
  }
};

const withRenderLog = (label, element) => {
  logMessage(label);
  return element;
};

const AUTH_TOKEN_SELECTOR = (state) => state.persistedReducer.token;
const bypassAuth = process.env.REACT_APP_BYPASS_AUTH === "true";

const theme = createTheme({
  status: {
    danger: "#e53e3e",
  },
  palette: {
    primary: {
      main: "#024634",
      darker: "#024634",
    },
    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },
  },
});

// Loga toda mudança de rota (pathname e querystring)
function RouteLogger() {
  const location = useLocation();
  useEffect(() => {
    logMessage(
      "[Routes] navegação:",
      location.pathname + (location.search || "")
    );
  }, [location]);
  return null;
}

const RotasPrivadas = () => {
  useEffect(() => {
    logMessage("[Routes] montando RotasPrivadas");
  }, []);
  return (
    <>
      <Routes>
        <Route
          path="/inicio"
          element={withRenderLog(
            "[Route] /inicio render",
            <PrivateRoute component={Inicio} />
          )}
        />
        <Route
          path="/sobre"
          element={withRenderLog(
            "[Route] /sobre render",
            <PrivateRoute component={Sobre} />
          )}
        />
        <Route
          path="/contato"
          element={withRenderLog(
            "[Route] /contato render",
            <PrivateRoute component={Contato} />
          )}
        />

        <Route
          path="/referencias"
          element={withRenderLog(
            "[Route] /referencias render",
            <PrivateRoute component={Referencias} />
          )}
        />
        <Route
          path="/pdf/:id?"
          element={withRenderLog(
            "[Route] /pdf/:id? render",
            <PrivateRoute component={Pdf} />
          )}
        />
        <Route
          path="/pdfCartograma/:numeroCar?"
          element={withRenderLog(
            "[Route] /pdfCartograma/:numeroCar? render",
            <PrivateRoute component={PdfCartograma} />
          )}
        />
        <Route
          path="/pdfCartogramaPrint/:numeroCar?"
          element={withRenderLog(
            "[Route] /pdfCartogramaPrint/:numeroCar? render",
            <PrivateRoute component={PdfCartogramaPrint} />
          )}
        />
        <Route
          path="/pdfSerieHistoria/:numeroCar?"
          element={withRenderLog(
            "[Route] /pdfSerieHistoria/:numeroCar? render",
            <PrivateRoute component={PdfSerieHistoria} />
          )}
        />
        <Route
          path="/pdfTabelaSintese/:numeroCar?"
          element={withRenderLog(
            "[Route] /pdfTabelaSintese/:numeroCar? render",
            <PrivateRoute component={PdfTabelaSintese} />
          )}
        />
      </Routes>
    </>
  );
};

const RotasPublicas = () => {
  useEffect(() => {
    logMessage("[Routes] montando RotasPublicas");
  }, []);
  const authToken = useSelector(AUTH_TOKEN_SELECTOR);
  const sanitizedToken = sanitizeToken(authToken);
  const shouldRedirectToInicio = bypassAuth || Boolean(sanitizedToken);
  return (
    <>
      <Routes>
        <Route
          path="/not-found"
          element={withRenderLog(
            "[Route] /not-found render",
            <PublicRoute component={PaginaNaoEncontrada} />
          )}
        />
        <Route
          path="/"
          element={withRenderLog(
            "[Route] / render",
            shouldRedirectToInicio ? (
              <Navigate to="/inicio" replace />
            ) : (
              <PublicRoute component={Login} />
            )
          )}
        />
        <Route
          path="/login"
          element={withRenderLog(
            "[Route] /login render",
            shouldRedirectToInicio ? (
              <Navigate to="/inicio" replace />
            ) : (
              <PublicRoute component={Login} />
            )
          )}
        />
        <Route
          path="/cadastro"
          element={withRenderLog(
            "[Route] /cadastro render",
            <PublicRoute component={Cadastro} />
          )}
        />
        {!shouldRedirectToInicio && (
          <Route
            path="*"
            element={withRenderLog(
              "[Route] * (fallback) render",
              <PublicRoute component={PaginaNaoEncontrada} />
            )}
          />
        )}
      </Routes>
    </>
  );
};

export const RoutesApp = () => {
  useEffect(() => {
    logMessage("[RoutesApp] inicializando rotas — bypassAuth =", bypassAuth);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Sidebar />
        {/* logger de navegação, sem alterar seu fluxo */}
        <RouteLogger />

        {/* mantém exatamente sua estrutura */}
        <RotasPrivadas />
        <RotasPublicas />
      </BrowserRouter>
    </ThemeProvider>
  );
};
